import { render, staticRenderFns } from "./CtaOne.vue?vue&type=template&id=12b10ad2&"
import script from "./CtaOne.vue?vue&type=script&lang=js&"
export * from "./CtaOne.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports